 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"profile": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"profile": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"dashboard":"dashboard","hoidap":"hoidap","keyword-reject":"keyword-reject","message":"message","raovat":"raovat","sanpham":"sanpham","static_pages":"static_pages"}[chunkId]||chunkId) + "." + {"chunk-2d0b997a":"d537cf5b","chunk-2d0c4673":"4c2cc18f","dashboard":"c3c87fb6","hoidap":"27d3a70e","keyword-reject":"93451e3c","message":"31eff1c9","raovat":"8f5f6451","sanpham":"1f644c1b","static_pages":"9d2cf2da","chunk-45ada79e":"ef0d2b5f","chunk-e5885efa":"580e3aed","chunk-2d0be31d":"1f4d2b95","chunk-2d0e9944":"06b7c557","chunk-2d22d9b6":"3cee7c96","chunk-1ce5c5fa":"441950d8","chunk-79ad4908":"55326f50","chunk-8d18dd74":"d221ed27","chunk-2d0b322f":"daf99c72","chunk-336d08ef":"557221f7","chunk-0e22ee8a":"8a099478","chunk-08a562bb":"4f1d19fb","chunk-179105ef":"a0d4f076","chunk-2770c4bc":"4e039094","chunk-29253128":"c0da0751","chunk-2d0aab0e":"688b7ee2","chunk-2d0ab4f4":"812f3913","chunk-2d0b611d":"ef811bcf","chunk-2d0baa70":"6fbb81c2","chunk-2d0c268a":"eef13958","chunk-2d0c42d3":"b6de62ec","chunk-2d0dab90":"742a8505","chunk-2d22bddf":"cdcce378","chunk-2d23721a":"f66400ff","chunk-30eda4ec":"a7f85e5e","chunk-373b4490":"8fb0f92d","chunk-396c2f6f":"cfa479e5","chunk-50940c6a":"c845a839","chunk-5ca91644":"383c3061","chunk-5db2184a":"72c3ae29","chunk-60fa70e6":"a9d3bf45","chunk-658bd0c0":"45e1d7e2","chunk-7d3f2b5d":"9a1e9035","chunk-7d5ad1f2":"c6fa8fcd","chunk-89ade112":"f1cf4e13","chunk-a29819a8":"48123972","chunk-be719c44":"b451f4a7","chunk-c1ca24c4":"686c15ab","chunk-0a86b4fc":"ab2d68af","chunk-0aaf0c44":"12bcca5f","chunk-0c536f0a":"0e3fe7f8","chunk-1041deba":"ea5c53f3","chunk-12db2fea":"747b51a9","chunk-14636918":"00f76d1c","chunk-2d0ac438":"e2c946de","chunk-2d0be175":"1844e956","chunk-2d0ccf19":"f837c4c3","chunk-2d0f007f":"c3d66421","chunk-2d225db8":"daaa503b","chunk-2d2315b6":"950bb53c","chunk-2d238682":"96ffa5e4","chunk-345741fe":"34ecf155","chunk-38fe3d20":"5938d9bf","chunk-447b3c2e":"dae63033","chunk-4a83cd75":"1927508d","chunk-4e8af26e":"4848c8da","chunk-50733007":"407cccb2","chunk-62be0550":"cd7b17b4","chunk-6bcee26b":"970aa4c8","chunk-6e0cb868":"afafc590","chunk-707d75da":"8ad6f874","chunk-77a85d16":"06bdcbff","chunk-7c1b03e0":"7fbb02f6","chunk-7c641170":"717bd9ee","chunk-87e6c23e":"a2b09cfa","chunk-b04382d0":"d046f2b0","chunk-fbfb1b3c":"e5a520a4","chunk-2d0cef7e":"e04df6e8","chunk-2d0dd6ad":"b4a1b814","chunk-47ec62d2":"9413b359","chunk-8387b838":"c1fb2e62","chunk-18eccb65":"2fb43c25","chunk-5b74926e":"b08fbc7f","chunk-1c53d456":"3889b73c","chunk-6ba93260":"636c9fa8"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"dashboard":1,"hoidap":1,"message":1,"raovat":1,"sanpham":1,"static_pages":1,"chunk-45ada79e":1,"chunk-e5885efa":1,"chunk-1ce5c5fa":1,"chunk-79ad4908":1,"chunk-8d18dd74":1,"chunk-336d08ef":1,"chunk-0e22ee8a":1,"chunk-08a562bb":1,"chunk-179105ef":1,"chunk-2770c4bc":1,"chunk-29253128":1,"chunk-30eda4ec":1,"chunk-373b4490":1,"chunk-396c2f6f":1,"chunk-50940c6a":1,"chunk-5ca91644":1,"chunk-5db2184a":1,"chunk-60fa70e6":1,"chunk-658bd0c0":1,"chunk-7d3f2b5d":1,"chunk-7d5ad1f2":1,"chunk-89ade112":1,"chunk-a29819a8":1,"chunk-be719c44":1,"chunk-c1ca24c4":1,"chunk-0a86b4fc":1,"chunk-0aaf0c44":1,"chunk-0c536f0a":1,"chunk-1041deba":1,"chunk-12db2fea":1,"chunk-14636918":1,"chunk-345741fe":1,"chunk-447b3c2e":1,"chunk-4a83cd75":1,"chunk-4e8af26e":1,"chunk-50733007":1,"chunk-62be0550":1,"chunk-6bcee26b":1,"chunk-6e0cb868":1,"chunk-707d75da":1,"chunk-77a85d16":1,"chunk-7c1b03e0":1,"chunk-7c641170":1,"chunk-87e6c23e":1,"chunk-b04382d0":1,"chunk-fbfb1b3c":1,"chunk-47ec62d2":1,"chunk-8387b838":1,"chunk-18eccb65":1,"chunk-5b74926e":1,"chunk-1c53d456":1,"chunk-6ba93260":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"dashboard":"dashboard","hoidap":"hoidap","keyword-reject":"keyword-reject","message":"message","raovat":"raovat","sanpham":"sanpham","static_pages":"static_pages"}[chunkId]||chunkId) + "." + {"chunk-2d0b997a":"31d6cfe0","chunk-2d0c4673":"31d6cfe0","dashboard":"eaa234e9","hoidap":"2d18e657","keyword-reject":"31d6cfe0","message":"3ef4753b","raovat":"dd85e860","sanpham":"5680290e","static_pages":"4ce81407","chunk-45ada79e":"1f2a769e","chunk-e5885efa":"59f46079","chunk-2d0be31d":"31d6cfe0","chunk-2d0e9944":"31d6cfe0","chunk-2d22d9b6":"31d6cfe0","chunk-1ce5c5fa":"d0925da5","chunk-79ad4908":"fba9120f","chunk-8d18dd74":"242bc9e8","chunk-2d0b322f":"31d6cfe0","chunk-336d08ef":"feeb5040","chunk-0e22ee8a":"70d43031","chunk-08a562bb":"ae913038","chunk-179105ef":"6efbfc31","chunk-2770c4bc":"23beb9d3","chunk-29253128":"7654cbe1","chunk-2d0aab0e":"31d6cfe0","chunk-2d0ab4f4":"31d6cfe0","chunk-2d0b611d":"31d6cfe0","chunk-2d0baa70":"31d6cfe0","chunk-2d0c268a":"31d6cfe0","chunk-2d0c42d3":"31d6cfe0","chunk-2d0dab90":"31d6cfe0","chunk-2d22bddf":"31d6cfe0","chunk-2d23721a":"31d6cfe0","chunk-30eda4ec":"4eb41324","chunk-373b4490":"6fba09fb","chunk-396c2f6f":"7654cbe1","chunk-50940c6a":"6efbfc31","chunk-5ca91644":"70d43031","chunk-5db2184a":"8d9bfd44","chunk-60fa70e6":"737bc98d","chunk-658bd0c0":"ec435d6a","chunk-7d3f2b5d":"ee046647","chunk-7d5ad1f2":"23beb9d3","chunk-89ade112":"9125e57c","chunk-a29819a8":"8d9bfd44","chunk-be719c44":"ccd452fb","chunk-c1ca24c4":"ae913038","chunk-0a86b4fc":"48101668","chunk-0aaf0c44":"ee046647","chunk-0c536f0a":"6fba09fb","chunk-1041deba":"cbeedca0","chunk-12db2fea":"579405d2","chunk-14636918":"d73bc803","chunk-2d0ac438":"31d6cfe0","chunk-2d0be175":"31d6cfe0","chunk-2d0ccf19":"31d6cfe0","chunk-2d0f007f":"31d6cfe0","chunk-2d225db8":"31d6cfe0","chunk-2d2315b6":"31d6cfe0","chunk-2d238682":"31d6cfe0","chunk-345741fe":"423c8f14","chunk-38fe3d20":"31d6cfe0","chunk-447b3c2e":"1a26d968","chunk-4a83cd75":"ee046647","chunk-4e8af26e":"f77365a9","chunk-50733007":"1a26d968","chunk-62be0550":"4f2179fe","chunk-6bcee26b":"3b440271","chunk-6e0cb868":"ee046647","chunk-707d75da":"6fba09fb","chunk-77a85d16":"fe58e387","chunk-7c1b03e0":"d63e5338","chunk-7c641170":"ccd452fb","chunk-87e6c23e":"ee046647","chunk-b04382d0":"fa55a239","chunk-fbfb1b3c":"cbda3735","chunk-2d0cef7e":"31d6cfe0","chunk-2d0dd6ad":"31d6cfe0","chunk-47ec62d2":"615b4dd7","chunk-8387b838":"10830da1","chunk-18eccb65":"42ebd769","chunk-5b74926e":"897d1ab1","chunk-1c53d456":"b8930875","chunk-6ba93260":"1569af5f"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/vue-cli/profile/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
